import { TicketCommonInformation, TicketTableHeader } from './ticket-transaction-table.types';

export const TICKET_TABLE_HEADER: TicketTableHeader[] = [
  {
    title: '№',
  },
  {
    title: 'transaction.ticket.item.name',
  },
  {
    title: 'transaction.ticket.item.section',
  },
  {
    title: 'transaction.ticket.item.price',
    isCurrency: true,
  },
  {
    title: 'transaction.ticket.item.quantity',
  },
  {
    title: 'transaction.ticket.item.measurement.unit',
  },
  {
    title: 'transaction.ticket.item.barcode',
  },
  {
    title: 'transaction.ticket.item.sum',
    isCurrency: true,
  },
];

export const TICKET_COMMON_INFORMATION: TicketCommonInformation[] = [
  {
    title: 'ticket.customer.iin.bin',
    property: 'customerIinOrBin',
    name: 'inn-bin',
  },
  {
    title: 'ticket.customer.phone',
    property: 'customerPhone',
    name: 'phone',
  },
  {
    title: 'ticket.customer.email',
    property: 'customerEmail',
    name: 'email',
  },
];
